import React from 'react';

export interface InlineEditContextValue {
  sectionId: string;
  componentId: string;
  controls: Record<string, any>;
  onControlChange: (sectionId: string, key: string, value: string) => void;
  isEditMode: boolean;
  /** project_id of the site — used by quiz_embed and similar components to scope their data */
  projectId?: string;
}

export const InlineEditContext = React.createContext<InlineEditContextValue | null>(null);
